import request from '@/sheep/request';

// 位置相关API
const LocationApi = {
  // 逆地理编码（通过后端中转，避免前端暴露AK）
  reverseGeocoding: (latitude: number, longitude: number, provider?: string) => {
    return request({
      url: '/system/geo/reverse-geocoding',
      method: 'GET',
      params: { latitude, longitude, provider }
    });
  },
  
  // 地理编码（地址转坐标）
  geocoding: (address: string) => {
    return request({
      url: '/system/geo/geocoding',
      method: 'GET',
      params: { address }
    });
  }
};

export default LocationApi;
